import { Link } from "react-router-dom";

interface CompanyCardProps {
    company: {
        id: string;
        name: string;
        description?: string;
        logo?: string;
        sector?: string;
        location?: string;
        jobCount?: number;
    };
}

/** Most seeded companies have no description, so fall back to a neutral label. */
const specialtyOf = (company: CompanyCardProps["company"]) => {
    const text = (company.description || "").trim();
    if (!text || /^no description/i.test(text)) return company.sector || "Energy Company";
    return text;
};

export const CompanyCard = ({ company }: CompanyCardProps) => {
    return (
        <div className="oec-company-card">
            <div className="oec-company-logo">
                {company.logo && !company.logo.includes("company-placeholder")
                    ? <img src={company.logo} alt="" loading="lazy"/>
                    : <span className="oec-company-wordmark">{company.name}</span>}
            </div>

            <p className="oec-company-type">
                <i className="fas fa-industry"/>
                <span>{specialtyOf(company)}</span>
            </p>

            <p className="oec-company-meta">
                <i className="fas fa-map-marker-alt"/>
                <span>{company.location || "Ethiopia"}</span>
                {company.jobCount !== undefined && (
                    <>
                        <span className="oec-company-divider">|</span>
                        <span>{company.jobCount} {company.jobCount === 1 ? "job" : "jobs"}</span>
                    </>
                )}
            </p>

            <Link className="oec-card-btn" to={`/company/${company.id}`}>
                View Profile <i className="fas fa-arrow-right"/>
            </Link>
        </div>
    );
};
